import React from 'react'
import "./UnderMaintenance.css"; // Import the CSS styles
import Lottie from "lottie-react";
import animationData from "../assets/undermaintenance.json";

const UnderMaintenance = () => {
  return (
    <div className="loader-container">
      <div>
        <Lottie animationData={animationData} loop={true} />
        <div className="contact-info">
          CONTACT US @ +91 9340011444
        </div>
      </div>
    </div>
  );
}

export default UnderMaintenance